export default "__VITE_ASSET__Cbbl71jf__"